import styled, { css } from "styled-components";
import { Heading1, SubHeading, CTAButtonWrapper } from "../../../../common/styled-components/styled-components";
import { breakpoints, device } from '../../../../../../app/js/utils/responsive_utilities';
import { white, codGrey, deepCoveDark } from '../../../../../../app/js/components/loggedout/shared-styles/Colors';
import { styledFont } from '../../../../common/mixins/mixin';


export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;

  background-color: ${deepCoveDark};
  ${styledFont("Graphie")}
  padding: 0 0 3rem;
  box-sizing: border-box;
`;
export const HeadingText = styled(Heading1)`
  color: ${white};
  margin: auto;
  padding-top: 3rem;
  ${styledFont("Graphie", 2.8, 3.2, 7)};
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 4, 4.8, 7)};
  }
`;

export const SubHeadingText = styled(SubHeading)`
  width: 100%;
  color: ${white};
  padding-top: 0.5rem;
  ${styledFont("Graphie", 1.6, 2, 6)};
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 2, 2.4, 6)};
  }
`;

export const FilterWrapper = styled.div`
  overflow-x: auto;
  padding: 2rem 1.6rem 3rem;
  position: sticky;
  top: -0.1rem;
`;

export const FilterList = styled.ul`
  display: flex;
  width: 40rem;
  margin: 0 auto;
  justify-content: center;
  padding-left: 0;

  @media (min-width: ${breakpoints.lg}px) {
    width: 100%;
  }
`;

export const ListItem = styled.li`
  background-color: ${props=>props.bgColor || '#48C8B0'};
  ${styledFont("Graphie", 2, 2.4, 7)};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4.4rem;
  height: 4.4rem;
  color: ${white};
  margin-right: 0.8rem;
  box-sizing: border-box;
  text-transform: capitalize;
  cursor: pointer;
  @media (min-width: ${breakpoints.lg}px) {
    width: 7.8rem;
    height: 7.8rem;
    margin-right: 2.5rem;
    ${styledFont("Graphie", 3.6, 4.4, 7)};
  }
  ${props=>props.selected ? css`
      border: 1rem solid ${props.selectedColor};
    ` : null
  };
  &:nth-of-type(1) {
    display: none;
    cursor: default;
    background-color: transparent;
    width: auto;
    @media (min-width: ${breakpoints.md}px) {
      display: flex;
    }
    @media (min-width: ${breakpoints.lg}px) {
      display: flex;
      ${styledFont("Graphie", 2.4, 2.8, 7)};
    }
  }
  &:nth-of-type(2) {
    width: 8.1rem;
    border-radius: 2.5rem;
    padding: -0 0.5rem;
    ${styledFont("Graphie", 1.8, 2.4, 7)};

    @media (min-width: ${breakpoints.lg}px) {
      width: 14.6rem;
      border-radius: 4.3rem;
      ${styledFont("Graphie", 2.4, 3, 7)};

    }
  }
`;

export const Card = styled.li`
  width: 34.3rem;
  max-width: 37rem;
  background-color: ${white};
  border-radius: 1.8rem;
  padding: 1.4rem 2.3rem;
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom: 3rem;
  img {
    width: 100%;
    min-height: 17.1rem;
    max-height: 19.5rem;
    margin: 1.7rem 0;
    border-radius: 1.6rem;
  }
  @media (min-width: ${breakpoints.md}px) {
    margin-bottom: unset;
    img {
      width: 100%;
    }
  }
  @media (min-width: ${breakpoints.lg}px) {
    width: 37rem;
    margin-bottom: unset;
    min-height: 54rem;
    img {
      min-width: 32.3rem;
      max-height: 18.7rem;
      margin: 1.7rem 0;
      width: 100%;
    }
  }
`;

export const CardWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 1rem 0 0rem;
  justify-content: space-around;
  list-style: none;
  padding: 0 1.6rem;
  @media (min-width: ${breakpoints.sm}px) {
    width: auto;
    justify-content: space-around;
    gap: unset;
    margin: 1rem auto;
  }
  @media (min-width: ${breakpoints.md}px) {
    width: 95%;
    margin: 1rem auto 0rem;

  }
  @media (min-width: ${breakpoints.lg}px) {
    width: 79rem;
    margin: 1rem auto 0rem;

  }
`;

export const SubjectTitle = styled.p`
  ${styledFont("Graphie", 2, 2.4, 7)};
  color: ${codGrey};
  margin: auto;
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 2.8, 3.4, 7)};
  }
`;

export const CgListWrapper = styled.ul`
  padding: 0;
  list-style-type: none;
`;

export const WaveWrapper = styled.div`
  background: ${white};

  img {
    display: block;
    width: 100%;
  }

`;

export const ButtonWrapper = styled(CTAButtonWrapper)`
  padding: 6rem 0 10rem 0;
  >div {
    width: 30rem;
  }
  @media ${device.Desktop}{
    padding: 8rem 0 10rem 0;
  }
`